import * as tslib_1 from "tslib";
import * as React from 'react';
import HeaderCharm from './HeaderCharm';
import strings from 'owa-strings/owa-common-strings';
import { WafflePane } from 'owa-header-pane';
import { observer } from 'mobx-react';
var styles = require('./Header.scss');
var WaffleCharm = /** @class */ (function (_super) {
    tslib_1.__extends(WaffleCharm, _super);
    function WaffleCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WaffleCharm.prototype.render = function () {
        return (React.createElement(HeaderCharm, { key: "waffle", icons: { iconName: "Waffle" /* Waffle */ }, title: strings.waffleCharm_ariaLabel, ariaLabel: strings.waffleCharm_ariaLabel, className: styles.waffle, activeClassName: styles.activeWaffle, behavior: {
                paneComponent: WafflePane,
                charm: 5 /* WaffleCharm */,
            } }));
    };
    WaffleCharm = tslib_1.__decorate([
        observer
    ], WaffleCharm);
    return WaffleCharm;
}(React.Component));
export default WaffleCharm;
//# sourceMappingURL=WaffleCharm.js.map